/**
 * Pagination schemas
 *
 * We use cursor-based pagination, not offset pagination.
 * Cursor pagination is more efficient and handles concurrent writes correctly.
 */

import { z } from "zod";

// Pagination query params
export const PaginationSchema = z.object({
	limit: z.coerce.number().int().min(1).max(100).default(20),
	cursor: z.string().optional(),
});
export type PaginationParams = z.infer<typeof PaginationSchema>;

// Pagination response shape
export const PaginationResponseSchema = z.object({
	cursor: z.string().nullable(),
	hasMore: z.boolean(),
});
export type PaginationResponse = z.infer<typeof PaginationResponseSchema>;
